import { i18n } from '@/locales';
import { convertCase } from '@/utils';
const { t } = i18n;
const lc = 'views.worker.worker_baromoney_history.';
export const workerBaromoneyType = {
    // 라이더 바로머니 자동 차감
    WORKER_BAROMONEY_AUTO_DEDUCTION: 'WORKER_BAROMONEY_AUTO_DEDUCTION',
    // 배달대행 내역
    DELIVERY_AGENCY_HISTORY: 'DELIVERY_AGENCY_HISTORY',
    // 입출금 내역
    DEPOSIT_WITHDRAWAL_HISTORY: 'DEPOSIT_WITHDRAWAL_HISTORY',
    // 기타
    ETC: 'ETC',
};
const workerBaromoneyTypeList = [
    workerBaromoneyType.WORKER_BAROMONEY_AUTO_DEDUCTION,
    workerBaromoneyType.DELIVERY_AGENCY_HISTORY,
    workerBaromoneyType.DEPOSIT_WITHDRAWAL_HISTORY,
    workerBaromoneyType.ETC,
];
const workerBaromoneyTypeOptionList = workerBaromoneyTypeList
    .map((value) => {
    const text = convertCase(value, 'enum', 'snake');
    return {
        text: t(lc + text),
        value,
    };
});
export { workerBaromoneyTypeOptionList };
